/* tslint:disable */

/**
 */
export class UDFCheck {
    function_name?: string;
    crack_raito?: string;
}
